import { useContext } from "react"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AppSpan, AppText, Button, CustomContainer, FlexRow, GridContainer, Icon, ScreenTitle } from "src/style"
import { banksImgLg } from "src/utils/logo"
import { LogoCreation } from "src/component"
import {CopyToClipboard} from 'react-copy-to-clipboard'


export const UssdCodeDetails: React.FC<any> = ({data, handleConfirm, back, close}) => {
    const {notifier} = useContext(VisibilityContext)

    const code =`*${data?.ussdCode}*27*${data?.sourceAccount || 'accountNumber'}*${data?.amount || 'amount'}#`

    return (
        <SidePopupLayout close={close}>
            <ScreenTitle textSize="2.2" fontWeight="700">Fund with USSD</ScreenTitle>
            <GridContainer topMargin='4'>
                <CustomContainer height="15" width="15">
                    { banksImgLg[data?.bank] ?
                        <Icon src={banksImgLg[data?.bank]} /> 
                        : <LogoCreation name={data?.bank} textSize='3' />
                    }
                </CustomContainer>
            </GridContainer>
            <GridContainer 
                bgColor="#E7F6F5" radius="0.8" borderColor="#E7F6F5"
                minHeight="12.5" padding="2" topPadding="1" bottomPadding="1"
                shadow="0px 1px 2px rgba(16, 24, 40, 0.05)"
            >
                <AppText textSize="1.2" color="#0A756F" align="center">
                    Dial the code below to complete this transaction with {data?.bank}'s {data?.ussdCode}
                </AppText>
                <AppText fontWeight="700" color="#0A756F" fontFamily="Gilmer-Bold">
                    {code}
                </AppText>
                <CopyToClipboard 
                    text={code}
                    onCopy={() => notifier.show(`USSD code copied successfully!`, '', 'success')}
                >
                    <AppSpan textSize="1.2" color="#0A756F" cursor="pointer" hoverColor="#101828">
                        Click to copy
                    </AppSpan>
                </CopyToClipboard>
            </GridContainer>
            <FlexRow justifyContent='center' gap="1.5" topMargin="2.5">
                <Button 
                    width='8.1' height='4' bgColor="#ffffff"
                    borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                    hoverColor='#0D968F' titleSize='1.4' color="#344054"
                    onClick={back}
                >
                    Cancel
                </Button>
                <Button 
                    width='15.2' height='4' 
                    borderColor='#0D968F' hoverBgColor='#ffffff' 
                    hoverColor='#0D968F' titleSize='1.4'
                    onClick={handleConfirm}
                >
                    Confirm Payment
                </Button>
            </FlexRow>
        </SidePopupLayout>
    )
}